var Palidziba = (function(scope) {

    var settings = {
        loading: false,
        last_page: '',
        category_container: '#main',
        question_container: '#question_modal',
        callback: '',
        login_callback: false,
        isMobile: ($(window).width() < 768)
    };

    scope.init = function() {

        if (history) {
            bindEvents();
        }

        var main_grid = $('#main div.grid');
        scope.masonry(main_grid);

        if (settings.isMobile) {
            scope.mobileFx();
        }

        function bindEvents() {

            $(document).on('click', 'a[data-category=true]', function(e) {
                e.preventDefault();

                $self = $(this);
                var url = scope.getUrl($self.attr("href"));

                scope.pjax(url, settings.category_container);
                return false;
            });

            $(document).on('click', 'a[data-question=true]', function(e) {
                e.preventDefault();

                $self = $(this);
                $self.addClass('visited');
                $self.parent().parent().find('.options a').addClass('visited');

                var url = scope.getUrl($self.attr("href"));

                $(settings.question_container).animate({
                    scrollTop: 0
                });

                if ($self.data('related')) {
                    scope.pjaxAlternate(url, settings.question_container);
                } else {
                    scope.pjax(url, settings.question_container);
                }
            });

            $(document).on('click', '#comment_yes', function() {
                $self = $(this);
                var $f = $('#feedback');
                var url = scope.getUrl($self.data("href"));

                scope.ajaxget(url, function(response) {
                    $f.addClass('response--sent');
                    $f.find('div.response-ok').show();
                    $f.find('.feedback__content').toggle();
                });
            });

            $(document).on('click', '#comment_no', function(e) {
                $self = $(this);
                var $f = $('#feedback');
                var url = scope.getUrl($self.data("href"));

                $('#comment_yes,#comment_no').attr('disabled', true);

                $f.find('div.response-nok').fadeIn();
                $f.addClass('btn-no-active response-disable');

                if (scope.overlayed()) {
                    $('#question_modal').animate({
                        scrollTop: $('#feedback').find('.feedback__options').position().top
                    });
                } else {
                    $('html').animate({
                        scrollTop: $('#feedback').position().top
                    });
                }

                scope.ajaxget(url);
            });

            $(document).on('submit', '#add_comment_form', function(e) {
                e.preventDefault();

                $self = $(this);
                var url = scope.getUrl($self.data('action'));
                var data = $self.serialize();

                scope.ajaxpost(url, data, function(response) {
                    if (response.status == 1) {
                        $self.removeClass('error');

                        $self.find('.question__title').hide();
                        $self.find('.comment__add--form').hide();
                        $self.find('.comment__add--ok').fadeIn();

                        $b = $('.option__item.item-comment');
                        $b.addClass('comment-sent');
                        $b.find('.button-content').hide();

                        $b.parent().removeAttr('data-toggle');
                        $b.parent().removeAttr('data-target');

                        scope.ajaxget('/get/constant/COMMENT_SENT_AD', function(adresponse) {
                            if (adresponse.length > 0) {
                                $self.find('.form--ad').html(adresponse).fadeIn();
                            }
                        });

                    } else {
                        $self.addClass('error');
                        $self.find('.error-text').html(response.message);
                    }
                });
            });

            $(document).on('click touchstart', '#question--close', function(e) {
                    history.back();
            });

            $('#login_form').on('submit', function(e) {
                e.preventDefault();

                $self = $(this);
                var url = scope.getUrl($self.data('action'));

                var hasError = false;
                $("#login_form :input").map(function() {
                    var $elem = $(this);
                    if (!$elem.val()) {
                        $elem.addClass('error');
                        $elem.next('label').addClass('active');
                        $elem.parent().find('.input-error').addClass('active');
                        hasError = true;
                    } else if ($elem.val()) {
                        $elem.removeClass('error');
                        $elem.next('label').removeClass('active');
                        $elem.parent().find('.input-error').removeClass('active');
                    }
                });

                if (hasError) {
                    return;
                }

                if (settings.login_callback) {
                    url += '?callback=1';
                }

                $.ajax({
                    type: 'post',
                    data: $self.serialize(),
                    url: url,
                    beforeSend: function() {
                        $('#form-loading').show();
                    },
                    success: function(response) {
                        if (response.status == 1) {
                            settings.login_callback = false;
                            location.reload();
                        } else {
                            $self.find('.error-block').html(response.error);
                        }

                    },
                    complete: function() {
                        $('#form-loading').hide();
                    }
                });


            });

            $(document).on('click', '#question--share', function() {

                $self = $(this);
                var url = scope.getUrl($self.data("action"));

                scope.ajaxget(url, function(response) {
                    $('#operatorShare .modal-content').html(response);
                    $('#operatorShare').modal('show');

                    scope.setInputEvents();
                });

            });

            $(document).on('submit', '#operator_share_form', function(e) {
                e.preventDefault();

                $self = $(this);
                var url = scope.getUrl($self.data("action"));
                var data = $self.serialize();

                $('#form-loading').show();
                $self.find('.status-msg').hide();

                scope.ajaxpost(url, data, function(response) {

                    if (parseInt(response.status) == 1) {
                        $self.find('.success-block').fadeIn();
                    } else {
                        $self.find('.error-block').html(response.message).fadeIn();
                    }

                    $('#form-loading').hide();
                });
            });

            $(document).on('submit', '#submit_question', function(e) {
                e.preventDefault();

                $self = $(this);

                $.ajax({
                    type: 'post',
                    data: $self.serialize(),
                    url: $(this).data('action'),
                    beforeSend: function() {
                        $('#form-loading').show();
                        $('textarea').removeClass('error');
                    },
                    success: function(response) {
                        $block = $('#ask_question__form');
                        if (typeof response.success !== 'undefined') {
                            $block.find('.form__wrapper').hide();
                            $block.find('.form--ok').fadeIn();

                            scope.ajaxget('/get/constant/QUESTION_SENT_AD', function(adresponse) {
                                if (adresponse.length > 0) {
                                    $block.find('.form--ad').html(adresponse).fadeIn();
                                }
                            });
                        }

                        if (response.error) {
                            $('textarea[name="' + response.error + '"]').addClass('error');
                        }

                    },
                    complete: function() {
                        $('#form-loading').hide();
                    }
                });


            });

            $(document).on('click', '.dropdown-menu a', function(e) {

                $self = $(this);

                $('.dropdown[data-level=' + $self.data('parent') + ']').find('.btn-text').html($self.text());
                $('.dropdown').not('.dropdown[data-level=0]').hide();
                if (typeof $self.data('open') != 'undefined') {
                    $('.dropdown[data-level=' + $self.data('open') + ']').show();
                }

                $('.infotext').hide();
                if (typeof $self.data('parentinfo') != 'undefined') {
                    $('#info' + $self.data('parentinfo')).show();
                }

                $('input[name="theme"]').val($self.data('key'));
                $('#info' + $self.data('key')).show();

            });

            if (settings.isMobile) {
                $('.top__header').on('click', function() {
                    $self = $(this);
                    $self.find('.icon-arrow_down_Accordion').toggleClass('open');
                    $self.next('.question__box').slideToggle();
                });
            }

            $(settings.category_container).on('pjax:complete', function() {
                if (typeof ga != 'undefined') {
                    ga('set', 'page', window.location);
                    ga('send', 'pageview');
                }

                $self = $(this);
                scope.masonry($self.find('.grid'));

                if (settings.isMobile) {
                    $('html, body').animate({
                        scrollTop: $('.main__heading').offset().top - 53
                    }, 300);
                }
            });

            $(settings.question_container).on('pjax:complete', function() {
                if (typeof ga != 'undefined') {
                    ga('set', 'page', window.location);
                    ga('send', 'pageview');
                }
                $(this).modal('show');

                $('.owl-carousel').owlCarousel({
                    singleItem: true,
                    transitionStyle: 'fade',
                    pagination: false,
                    autoHeight: true
                });

                $ac = $('.accordion');
                $ac.find('.accordion-item:first').toggleClass('open');
                $ac.find('.accordion-item:first div').slideToggle();

                $ac.find('.accordion-item').on('click', function() {
                    $self = $(this);
                    $self.toggleClass('open');
                    $self.find('div').slideToggle();
                });

                $(".gallery").trigger('destroy.owl.carousel');
                $(".owl-thumbs").trigger('destroy.owl.carousel');

                gallery_init();

                $('[data-toggle="tooltip"]').tooltip();
            });

            $(window).on('pjax:error', function() {
                location.reload();
            });

            $(window).on('pjax:popstate', function() {
                if (typeof ga != 'undefined') {
                    ga('set', 'page', window.location);
                    ga('send', 'pageview');
                }

                if ($(settings.question_container).hasClass('in')) {
                    $(settings.question_container).modal('hide');
                }
            });

            if (settings.isMobile) {
                $(window).on("scroll", function() {
                    scope.mobileFx();
                });
            }

            $(window).on("scroll", function(e) {
                if (!settings.isMobile) {
                    var fromTop = $(this).scrollTop();
                    if (fromTop > 50) {
                        $("body").addClass('scroll-position');
                    } else {
                        $("body").removeClass('scroll-position');
                    }
                }
            });

            $(window).bind('orientationchange', function(event) {

                scope.masonry(main_grid);
                $('.easy-autocomplete').css({
                    'width': 'auto'
                });
            });

            $('header .open-mobile-search').on('click', function() {
                $self = $(this);
                $self.hide();

                setTimeout(function(){
                    $('#search-mobile--input').trigger('focus');
                }, 0);

                $header = $('header');
                $header.find('.navbar-toggle.menu-toggle:not(.collapsed)').trigger('click');
                $header.find('.menu-toggle, .navbar-brand').hide();
                $header.find('.mobile-search').addClass('open');

                scope.addAutoComplete();
            });

            $('#login').on('shown.bs.modal', function() {
                if (typeof afteraction !== 'undefined' && afteraction === 'socloginrelation') {
                    $('#login_form .error-box').fadeIn();
                }
            });

            $('#login').on('hidden.bs.modal', function() {
                $('#login_form .error-box').hide();
                if (typeof afteraction !== 'undefined') {
                    afteraction = '';
                }
            });

            $(window).on("click", function(e) {
                if (!settings.isMobile) {
                    return;
                }

                $mobile_input = $('#search-mobile--input');
                var v = $mobile_input.is(":visible");

                var t = e.target;
                var hideme = true;
                var ppc = t.parentElement.parentElement.classList

                if (t.id == 'search-mobile--input' || t.getAttribute("class") == 'eac-item') {
                    hideme = false;
                }

                if (t.parentElement.classList.contains('open-mobile-search')) {
                    return;
                }

                if (t.nodeName == 'use') {
                    e.stopPropagation();
                    if (ppc.contains('search-toggle') || ppc.contains('navbar-header')) {
                        if (t.parentElement.classList.contains('icon-search') || t.parentElement.classList.contains('icon-delete')) {
                            hideme = false;
                        }
                    }
                }

                if (v && hideme) {
                    $header = $('header');
                    $header.find('.menu-toggle, .navbar-brand, .open-mobile-search').show();
                    $header.find('.mobile-search').removeClass('open');
                }
            });

            scope.setInputEvents();
        }
    };

    scope.mobileFx = function() {

        var fromTop = $("body").scrollTop();

        $main = $('.main__heading');
        $contact = $('.contact__heading');
        $btn = $('#super-back-button');

        if ($btn.length) {
            if (fromTop > $main.offset().top && fromTop < $('.categories').outerHeight() + 40) {
                $btn.fadeIn();
            } else {
                $btn.fadeOut();
            }
        }
    };

    scope.addAutoComplete = function() {
        var suggestUrl = $('.supersearch').attr('data-suggest');
        var options = {
            url: function(phrase) {
                return encodeURI(suggestUrl + encodeURIComponent(phrase)+ "?json=1");
            },

            getValue: "title",
            minCharNumber: 3,
            requestDelay: 400,
            list: {

                match: {
                    enabled: true
                },

                onClickEvent: function() {
                    $('#searchtopholder').submit();
                }

            }

        };

        if (settings.isMobile) {
            $("#search-mobile--input").easyAutocomplete(options);
        } else {
            $(".supersearch").easyAutocomplete(options);
        }
    };

    scope.masonry = function(element) {
        if (element.length && $(window).width() > 767) {
            $(element).masonry({
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true
            });
        }
    };

    scope.getUrl = function(url) {
        return (typeof print_debug !== 'undefined' ? url + '?print_debug=echo_text' : url);
    };

    scope.pjax = function(url, container) {
        $.pjax({
            type: 'POST',
            url: url,
            scrollTo: false,
            container: container
        });
    };

    scope.pjaxAlternate = function(url, container) {
        $.pjax({
            type: 'POST',
            url: url,
            replace: true,
            scrollTo: false,
            container: container
        });
    };

    scope.ajaxget = function(url, callback) {
        $.ajax({
            type: 'get',
            url: url,
            success: callback
        });
    };

    scope.ajaxpost = function(url, data, callback) {
        $.ajax({
            type: 'post',
            data: data,
            url: url,
            success: callback
        });
    };

    scope.overlayed = function() {
        return ($(settings.category_container).length > 0 || $('#search__results').length);
    };

    scope.setInputEvents = function() {
        $('input[type="text"], input[type="password"]').on('focus', function() {
            $self = $(this);

            if (!$self.val()) {
                $self.removeAttr('style');
                $self.next('label').addClass('active');
            } else {
                $self.css({
                    'border-bottom': '1px solid #000'
                });
            }
        });

        $('input[type="text"], input[type="password"]').on('blur', function() {
            $self = $(this);
            if (!$self.val()) {
                $self.removeAttr('style');
                $self.addClass('error');
                $self.parent().find('.input-error').addClass('active');
            } else {
                $self.css({
                    'border-bottom': '1px solid #000'
                });
            }
        });

        $('input[type="text"], input[type="password"]').on('change', function() {
            $self = $(this);
            if (!$self.val()) {
                $self.removeAttr('style');
                $self.addClass('error');
                $self.parent().find('.input-error').addClass('active');

            } else {
                $self.css({
                    'border-bottom': '1px solid #000'
                });

                $self.parent().find('.input-error').removeClass('active');
            }
        });
    };

    return scope;

})(Palidziba || {});

(function($) {
    Palidziba.init();

    $.fx.speeds._default = 200;

    document.addEventListener("DOMContentLoaded", function() {
        var elements = document.getElementsByTagName("input");
        for (var i = 0; i < elements.length; i++) {
            elements[i].oninvalid = function(e) {
                e.target.setCustomValidity("");
                if (!e.target.validity.valid) {
                    e.target.setCustomValidity(customValidatorMessage);
                }
            };
            elements[i].oninput = function(e) {
                e.target.setCustomValidity("");
            };
        }
    });

    var suggestUrl = $('.typeahead').attr('data-suggest');
    var options = {
        url: function(phrase) {
            return encodeURI(suggestUrl + encodeURIComponent(phrase)+ "?json=1");
        },

        ajaxSettings: {
            beforeSend: function(xhr) {
                $input = $('#eac-container-search--input');
                $input.html('<ul><li id="test-loader"><div class="loader02" style="color: #b0b4c1;"></div></li></ul>');
                $input.trigger('show.eac');
            }
        },

        getValue: "title",
        minCharNumber: 3,
        requestDelay: 600,
        list: {

            onShowListEvent: function() {
                $('.search__me').addClass('open');
            },

            onHideListEvent: function() {
                $('.search__me').removeClass('open');
            },

            onChooseEvent: function() {
                var elem = $("#search--input").getSelectedItemData();
                if (elem.empty) {
                    $('#searchholder.form-control-clear').trigger('click');
                    return;
                }

                $('#searchholder .search__me').trigger('click');
            },
        },

        ajaxCallback: function(response) {
            if (response.length == 1 && response[0].empty === true) {
                $('#eac-container-search--input ul').css({
                    'text-align': 'center'
                });
            } else {
                $('#eac-container-search--input ul').css({
                    'text-align': 'left'
                });
            }
        }

    };

    $("#search--input").easyAutocomplete(options);

    $('input[type="search"]').on('input propertychange', function() {
        var $this = $(this);
        var visible = Boolean($this.val());
        $('.form-control-clear').toggleClass('hidden', !visible);
    }).trigger('propertychange');

    $('.form-control-clear').click(function(e) {
        if( $('input[type="search"]').val()){
            e.preventDefault();
            e.stopPropagation();
            $('input[type="search"]').val('');
        }
    });

    $('#search--input, .form-control-clear').on('focus', function(e) {
        $('#overlay,header .header-overlay').fadeIn(function(){

			if ($(window).width() < 1281) {
				var input_position = $('#search--input').offset().top;
				$('html, body').animate({
					scrollTop: input_position / 2
				}, 300);
			}
		});

        $('#banner .operator_share').fadeOut();
        $('html, body').addClass('overlay');
    });

    $('#search--input, .form-control-clear').on('blur', function() {
        if ($(window).width() < 1281) {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        }

        $('#overlay,header .header-overlay,#banner .operator_share').fadeOut();
        $('#banner .operator_share').fadeIn();
        $('html, body').removeClass('overlay');
    });

    if (typeof afteraction !== 'undefined') {
        if (afteraction === 'askquestion') {
            $('a[data-askquestion="true"]')[0].click();
        }
    }

    if ($('.bxslider').length) {
        var slider = $('.bxslider').bxSlider({
            auto: true,
            pagerCustom: '#bx-pager'
        });
    }

    if ($('#search__results').length) {
        var position = $(window).scrollTop();
        $('html, body').animate({
            scrollTop: (position === 0 ? $('#search__results').offset().top - 53 : position)
        }, 600);
    }

})(jQuery);


$(document).ready(function() {
    $ac = $('.accordion');
    $ac.find('.accordion-item:first').toggleClass('open');
    $ac.find('.accordion-item:first div').slideToggle();

    $ac.find('.accordion-item').on('click', function() {
        $self = $(this);
        $self.toggleClass('open');
        $self.find('div').slideToggle();
    });

    if ($('.gallery').length) {
        gallery_init();
    }

    $('[data-toggle="tooltip"]').tooltip();
});

$(window).load(function() {
    if ($('.categories.level-2,.categories.level-3,.categories.level-4').length) {
        $('html, body').animate({
            scrollTop: $('.main__heading').offset().top - 53
        }, 500);
    }
});

function gallery_init() {
    var $sync1 = $(".gallery");
    var $sync2 = $(".owl-thumbs");

    $sync1.owlCarousel({
        items: 1,
        margin: 10,
        nav: true,
        dots: false,
        lazyLoad: true,
        autoHeight: true,
        onChanged: onChanged
    });

    $sync2.owlCarousel({
        items: 5,
        margin: 10,
        nav: false,
        dots: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        responsive: {
            0: {
                margin: 0
            },
            600: {
                margin: 5
            },
            1200: {
                margin: 10
            }
        }
    });


    function onChanged(prop) {
        $(".owl-thumbs .item").removeClass('activated');
        $(".owl-thumbs .item").eq(prop.item.index).addClass('activated');
    }

    $sync2.on("click", ".item", function(event) {
        event.preventDefault();

        $(".owl-thumbs .item").removeClass('activated');

        $self = $(this);
        $self.addClass('activated');
        $sync1.trigger("to.owl.carousel", $self.data("item"));
    });
}
